export function isParticipantInactive(participant) {
    const {
        status_flags: {cancelled, active, invite_sent},
    } = participant;

    return !cancelled && !active && !invite_sent;
}
